function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.1 57.97c0-7.67-6.12-13.46-14.09-13.46-7.99 0-14.1 6.11-14.1 13.46 0 7.67 6.11 13.63 14.1 13.63 7.97 0 14.09-6.26 14.09-13.63z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100 193.84c-51.75 0-93.84-42.1-93.84-93.84S48.25 6.16 100 6.16s93.84 42.1 93.84 93.84-42.09 93.84-93.84 93.84zm0-176.68c-45.68 0-82.84 37.16-82.84 82.84s37.16 82.84 82.84 82.84 82.84-37.16 82.84-82.84S145.68 17.16 100 17.16z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.33 154.8c-6.08 0-11-4.92-11-11V93.18c0-6.08 4.92-11 11-11s11 4.92 11 11v50.62c0 6.07-4.92 11-11 11z"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.09a9e4dd.svg";
export { ForwardRef as ReactComponent };